module.exports = __webpack_public_path__ + "img/carrito2.63decc51.png";